import { Skeleton } from '@/components/atoms/skeleton';

export const AuthFormSkeleton = () => {
  return (
    <div className="flex flex-col gap-6 rounded-dpDefault bg-dp-white p-8 shadow-dpCard dp-md:w-[400px]">
      <Skeleton width={140} height={28} />
      <div className="flex flex-col gap-2">
        <Skeleton width={64} height={14} />
        <Skeleton width="100%" height={40} />
      </div>
      <div className="flex flex-col gap-2">
        <Skeleton width={80} height={14} />
        <Skeleton width="100%" height={40} />
      </div>
      <Skeleton width="100%" height={44} />
      <div className="flex justify-center">
        <Skeleton width={180} height={14} />
      </div>
    </div>
  );
};
